import {HttpService} from "../../App/services/http";
import {ILoginState} from "../interfaces/login";

export const AuthServices = {
  login: (data: ILoginState) => HttpService.post('/auth/login', data),
  logout: () => HttpService.post('/auth/logout'),
};

export default AuthServices;